import {Component, OnInit} from '@angular/core';
import {AuthService} from "../../../services/mygreencountry/auth.service";
import {LANGUAGES} from "../../constants";

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
    public facebookUrl = 'https://www.facebook.com/greencountryschool/';
    public youTubeUrl = 'https://www.youtube.com/channel/UCLAEh5y7yZi15Q4VVUolSiA/';
    public instagramUrl = 'https://www.instagram.com/green_country_official/';
    public tiktokUrl = 'https://www.tiktok.com/@greencountry_school';
    public telegramUrl = 'https://t.me/englishnowgc';

    public isStudent: boolean = false;
    public isParent: boolean = false;


    public activeLanguage: string = LANGUAGES[0]['value']
    public selectedLanguageIcon: string = LANGUAGES[0]['image']
    availableLanguages: any = [];


    constructor(
        private authService: AuthService,
    ) {
    }

    getCurrentYear(): number {
        return new Date().getFullYear();
    }

    ngOnInit() {
        if (this.authService.isStudent()) {

            this.isStudent = true;

        } else if (this.authService.isParent()) {
            if (this.authService.getLoginRole() === 'parent') {
                this.isParent = true;
            } else {
                this.isStudent = true;
            }

        }
    }
}
